<template>
  
 <div>
    <div class="overlay">Fixed</div>
    <div class="animated fadeIn">
      <div class="card">
        <div class="card-header">
          <span>Điểm đến</span>
          <div class="card-header-actions"></div>
        </div>
        <div class="card-body">
          
            <b-row>
              <b-col md="12">
              Cập nhật thành công!
              </b-col>
            </b-row>
        </div>
      </div>
    </div>
 </div>
</template>

<script>


export default {
  data() {
    return {
    
    };
  },

  methods: {
    //get list table
    async fn_initTable() {
      $('body').css('display','none')
    },

    //xử lý dữ liệu đầu ra
    async changeData(data) {},

    

    async fn_initDataDefault() {},

    fn_hashUrl() {
      let type = location.search&& location.search.indexOf("khaibaongay") === -1 ? 'khaibaongay' : 'khaibaoantoan';
      let pathLocation = "/admin/DangKyDDAT";
      window.top.redirectToDangKyDDAT(pathLocation, type);
    }
  },

  //run after render view
  created() {
    this.fn_initDataDefault();
    this.fn_hashUrl();
  },
  mounted() {
    this.fn_initTable();
  }
};
</script>
